import { createApi } from "@reduxjs/toolkit/query/react";
import { baseProxyQueryWithReauth } from "./slices/API";

const el: any = document.querySelector("#app");
export const { contactsClientId, apiBase, csrfToken } = JSON.parse(
  el?.dataset?.page ?? ""
).props;

export type InboundCampaignType = {
  Uuid?: string;
  Label: string;
  Description: string;
  Reference: string;
  IsWildcard: boolean;
  Inbound: string;
  Status: string;
  Hits: number;
  Channel: "sms" | "email" | "voice";
  CreatedBy: string;
  UpdatedBy: string;
  CreatedAt: string;
  UpdatedAt: string;
  IsDeliveryStatus: boolean;
  DeliveryStatusGroup: string;
  DeliveryStatusLetter: string;
  Do: string;
  ProjectId: number;
  Keywords: string;
  ForwardMethod: string;
  ForwardTo: string;
  DynamicHeader: string;
  UseNumber: string;
  UseThread: boolean;
  Category: string;
  Industry: string;
  Message: {
    Plain: "";
    Rendered: "";
    EditorState: any;
  };
};

// Define a service using a base URL and expected endpoints
export const inboundCampaignProxyAPI = createApi({
  reducerPath: "inboundCampaignProxyAPI",
  baseQuery: baseProxyQueryWithReauth("logic/workflows/api"),
  refetchOnMountOrArgChange: true,
  tagTypes: ["InboundCampaigns"],
  endpoints: (builder) => ({
    upsertInboundCampign: builder.mutation<any, Partial<InboundCampaignType>>({
      query: (body) => ({
        url: `inbound-rule-handlers`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["InboundCampaigns"],
    }),
    getInboundCampaign: builder.query<InboundCampaignType, string>({
      query: (uuid) => `inbound-rule-handlers/${uuid}`,
      providesTags: ["InboundCampaigns"],
    }),
    deleteInboundCampaign: builder.mutation<any, string>({
      query: (uuid) => ({
        url: `inbound-rule-handlers/${uuid}`,
        method: "DELETE",
      }),
      invalidatesTags: ["InboundCampaigns"],
    }),
    getInboundCampaigns: builder.query<
      { items: InboundCampaignType[]; total: number },
      {
        limit?: number;
        offset?: number;
        search?: string;
        kind?: string;
        order_by?: "created_at" | "updated_at" | "inbound" | "label" | "hits";
        order?: "asc" | "desc";
        inbound?: string;
        channel?: ("sms" | "email" | "voice")[];
        status?: "active" | "inactive" | "";
        is_wildcard?: boolean;
      }
    >({
      query: (params) => ({
        url: `inbound-rule-handlers`,
        method: "GET",
        params,
      }),
      providesTags: ["InboundCampaigns"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useUpsertInboundCampignMutation,
  useGetInboundCampaignsQuery,
  useGetInboundCampaignQuery,
  useDeleteInboundCampaignMutation,
  useLazyGetInboundCampaignsQuery,
  useLazyGetInboundCampaignQuery,
} = inboundCampaignProxyAPI;
